import { Box, FormControl, InputLabel, SxProps } from '@mui/material';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { useSxStyles } from '~/scenes/PortalModules/Analytics/common/ReportDatasetLayout/useStyles';
import { mergeSxProps } from '~/utils/helpers/sxProps';

type PropsType = {
  showHeading?: boolean;
  sx?: SxProps;
  children: ReactNode;
};

export const ReportDatasetLayout = (props: PropsType) => {
  const { showHeading, children, sx } = props;

  const { t } = useTranslation();
  const sxStyles = useSxStyles();

  return (
    <Box sx={mergeSxProps(sxStyles.root, sx)}>
      {showHeading ? (
        <FormControl>
          <InputLabel shrink={true} focused={false}>
            {t('dataset')}
          </InputLabel>
          <Box sx={sxStyles.content}>{children}</Box>
        </FormControl>
      ) : (
        children
      )}
    </Box>
  );
};
